import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Checkbox,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GeneralButton } from "../../common/ui/GeneralButton";
import { ShopModule } from "../../types/shopModuleTypes";
import { useShopModules } from "../../store/selectors/shopModulesSelector";
import ShopButton from "../common/table/ShopButton";
import { ShopListItemStyles } from "./SelectShopModulesDialog.styles";

interface Props {
  onClose: () => void;
  selectedShops: ShopModule[];
  handleOnSave: (newSelectedShopModules: ShopModule[]) => void;
}

export default function SelectShopModulesDialog(props: Props) {
  const shopModules = useShopModules();
  const { t } = useTranslation();

  const [selectedShopModules, setSelectedShopModules] = useState(props.selectedShops);

  useEffect(() => {
    setSelectedShopModules(props.selectedShops)
  }, [props.selectedShops]);

  return (
    <Dialog open={true} onClose={props.onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("groupsPage.groups.selectShopModules")}</DialogTitle>
      <DialogContent>
        {shopModules.length === 0 
          ? <>{t("groupsPage.shopModules.noShopModulesFound")}</>
          : shopModules.map((item) => {
              const isSelected = selectedShopModules.find((a) => a.id === item.id) !== undefined;
              return (
                <ShopListItem
                  key={item.id}
                  item={item}
                  isShopSelected={isSelected}
                  handleIsSelectedChange={(isSelected) => {
                    if (isSelected) {
                      setSelectedShopModules([...selectedShopModules, item]);
                    }
                    else {
                      setSelectedShopModules(selectedShopModules.filter(
                        (action) => action.id !== item.id
                      ));
                    }
                  }}
                />
              );
            })
        }
      </DialogContent>
      <DialogActions>
        <GeneralButton appVariant="secondary" onClick={props.onClose}>
          {t("buttons.cancel")}
        </GeneralButton>
        <GeneralButton onClick={() => props.handleOnSave(selectedShopModules)}>
          {t("buttons.apply")}
        </GeneralButton>
      </DialogActions>
    </Dialog>
  );
};

interface ShopsListItemProps {
  item: ShopModule;
  isShopSelected: boolean;
  handleIsSelectedChange: (newSelected: boolean) => void;
}

function ShopListItem({ item, isShopSelected, handleIsSelectedChange }: ShopsListItemProps) {
  const { t } = useTranslation();
  return (
    <ShopListItemStyles>
      <Box sx={{ gap: 2 }}>
        <ShopButton type={item.type} showTooltip={false}/>
        <Typography>{t(`groupsPage.shopModules.${item.type}`, item.type)}</Typography>
      </Box>
      <Checkbox
        checked={isShopSelected}
        onChange={(e) => handleIsSelectedChange(e.target.checked)}
        sx={(theme) => ({ color: theme.palette.companyMain.main })}
        slotProps={{ input: { "aria-label": "controlled" } }}
      />
  </ShopListItemStyles>
  );
};